export function capitalize(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const randomString = function (length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

export function checkLastTwoAreNumbers(str: string) {
    return /\d{2}$/.test(str);
}